import {inject, Injectable} from '@angular/core';
import {catchError, Observable, tap, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {GeoservicesEndpoints} from '../../enums/endpoints.enum';
import {ApiUrlService} from '../apiUrl/api-url.service';
import {HttpService} from '../http/http.service';
import {MarkerData} from './../../../libs/az-geolocator/interfaces/markers';
import {RoutingEnum} from '../../enums/routing.enum';
import {HttpParams} from '@angular/common/http';
import {GeoservicesUrlService} from '../geoservices-url/geoservices-url.service';
import {PermissionService} from '../permission/permission.service';

@Injectable({
  providedIn: 'root',
})
export class ContactsMapService {
  constructor(
    private httpService: HttpService,
    private apiUrlService: ApiUrlService,
    private geoservicesUrlService: GeoservicesUrlService,
    private permissionService: PermissionService,
  ) {}

  getAgencyByBounds(
    bounds: google.maps.LatLngBounds,
  ): Observable<{response: MarkerData[]; status: 'OK' | 'KO'}> {
    const url = this.apiUrlService.getUrl(
      GeoservicesEndpoints.AGENCY_MARKERS,
      this.geoservicesUrlService.getGeoservicesBaseUrl(),
    );
    const bj = bounds.toJSON();
    // const boundsArr = bounds.toUrlValue().split(',');
    // boundsArr.unshift(url);
    // const urlString = boundsArr.join('/');
    const urlString = [url, bj.south, bj.west, bj.north, bj.east].join('/');

    return this.httpService.get(urlString, undefined, false);
  }

  getAgencyByDist(
    latLng: google.maps.LatLng,
  ): Observable<{response: MarkerData[]; status: 'OK' | 'KO'}> {
    const url = this.apiUrlService.getUrl(
      GeoservicesEndpoints.AGENCY_BYDIST,
      this.geoservicesUrlService.getGeoservicesBaseUrl(),
    );

    const urlString = [url, latLng.lat(), latLng.lng()].join('/');

    return this.httpService.get(urlString, undefined, false);
  }

  getAgencyByCod(cod: string): Observable<{response: MarkerData[]; status: 'OK' | 'KO'}> {
    const geoBaseUrl = this.apiUrlService.getUrl(
      GeoservicesEndpoints.AGENCY_DETAILS,
      this.geoservicesUrlService.getGeoservicesBaseUrl(),
    );
    const geoUrl = [geoBaseUrl, ...cod.split('-')].join('/');

    return this.httpService.get(geoUrl, undefined, false).pipe(
      catchError((err) => {
        this.permissionService.setBuyPermissionFromAgency(false);
        return throwError(() => err);
      }),
      tap((res) => {
        this.permissionService.setBuyPermissionFromAgency((res?.response ?? []).length > 0);
      }),
    );
  }

  createimgUrl(markerData: MarkerData) {
    //352*200
    const path =
      window.location.href.replace(RoutingEnum.AllianzPaySummary, '') +
      'assets/images/geolocator/pin_selected.svg';

    const url = 'https://maps.googleapis.com/maps/api/staticmap';
    const attr = {
      size: '500x284',
      maptype: 'roadmap',
      map_id: environment.mapId,
      markers: `icon:${path}|${markerData.lat},${markerData.lng}`,
      key: environment.mapsToken,
      style: 'feature:poi|visibility:off',
    };
    const params = new HttpParams({fromObject: attr}).toString();

    return `${url}?${params}`;
  }
}
